// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import exclamation from './exclamation.svg';

type Props = {|
  children: Node,
|};

export function ErrorDisplay({ children }: Props): Node {
  return (
    <ErrorWrapper>
      <IconWrapper>
        <Icon src={exclamation} alt="exclamation icon"/>
      </IconWrapper>

      <TextWrapper>
        {children}
      </TextWrapper>
    </ErrorWrapper>
  );
}

const ErrorWrapper = styled.div`
    background: #ffea94;
    border: 1px solid #f1c40f;
    display: flex;
`;

const IconWrapper = styled.div`
    display: inline-flex;
    background: #f1c40f;
    flex: 0 1 40px;
    align-items: center;
    justify-content: center;
    font-family: "Open Sans","OpenSans",Arial,"Helvetica Neue",Helvetica,sans-serif;
    border-radius: 2px 0 0 2px;
`;

const TextWrapper = styled.div`
    color: #856831;
    padding: 15px;
    flex: 1 1 0;
    font-size: 12px;
`;

const Icon = styled.img`
    width: 5px;
    vertical-align: middle;
`;
